import React from "react";
import ReactDOM from "react-dom/client";
import cn from "classnames";
import Collapse from "championship/src/components/Collapse";
import {createStore, withStore} from "game_play/utils/store";
import DatePicker, {renderInputDateStepper} from "championship/src/components/DatePicker";
import Tournaments, {toRequestDate} from "../model/tournaments";
import EmptyState from "championship/src/components/EmptyState/emptyState";

import '../static/tournament/style/tournaments.css'
import {GameRowPlayer} from "./utils";

const formattedDate = new Intl.DateTimeFormat('ru-RU', {
  day: '2-digit',
  month: '2-digit',
  year: 'numeric'
});


class TableTournaments extends React.Component {
  state = {
    date: null,
    opened: {}
  }

  unsubscribeSocket = null

  handlerRowClick = (tournament, handler) => (e) => {
    if (e.target.closest('[data-inside-link]')) return;
    if (e.target.closest('[data-inside-button]')) {
      e.preventDefault();
      return;
    }

    if (handler && handler(tournament)) {
      e.preventDefault()
    }
  }

  toggleGame = (tournament) => {
    if (tournament.games.length) {
      this.setState((state) => {
        state.opened[tournament.id] = !state.opened[tournament.id]
        return state
      })
      return true
    }
    return false
  }

  handlerShiftDay = (shift) => () => {
    if (!this.state.date) this.setState({date: new Date()})
    const newDate = new Date(this.state.date);
    newDate.setDate(this.state.date.getDate() + shift);
    this.setState({date: newDate})
  }

  fetchTournaments() {
    const {Tournaments} = this.props
    const requestDate = toRequestDate(this.state.date)
    Tournaments.fetch({date: requestDate}, true).then((tournaments) => {
      this.setState((state) => {
        tournaments.forEach((tournament) => {
          if (!(tournament.id in state)) {
            state.opened[tournament.id] = Tournaments.isLive(tournament)
          }
        })
        return state
      })
    })
    if (this.unsubscribeSocket) this.unsubscribeSocket()
    // this.unsubscribeSocket = Tournaments.subscribe({date: requestDate})
  }

  componentDidMount() {
    this.fetchTournaments()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.state.date !== prevState.date) {
      this.fetchTournaments()
    }
  }

  componentWillUnmount() {
    if (this.unsubscribeSocket) {
      this.unsubscribeSocket()
    }
  }

  render() {
    const {Tournaments, Requests} = this.props
    const tournaments = Tournaments.get('tournaments')
    const {opened, date} = this.state

    return (
      <div>
        <div className='tournaments-naviagation'>
          <div/>
          <DatePicker
            className='tournament-date-picker'
            value={date}
            onChange={(date) => {
              this.setState({date})
            }}
            renderInput={renderInputDateStepper}
          />
        </div>
        <div className='tournaments-table-body'>
          {Tournaments.get('status') === 'loading' ? (
            <div className='loader-ui'>
              <div/>
              <div/>
              <div/>
              <div/>
              <div/>
            </div>
          ) : !tournaments.length && (
            <EmptyState prev={this.handlerShiftDay(-1)} next={this.handlerShiftDay(1)}/>
          )}
          {tournaments.map(tournament => (
            <React.Fragment key={tournament.id}>
              <a href={tournament.absolute_url}
                 className='tournament-row' onClick={this.handlerRowClick(tournament, this.toggleGame)}>
                <div className="tournament-row__logo">
                  <a href={tournament.league.absolute_url} data-inside-link>
                    <img src={tournament.league.image} alt={tournament.league.name}/>
                  </a>
                </div>
                <div className='tournament-row__body'>
                  <div className="tournament-row__name">
                    <a href={tournament.league.absolute_url} data-inside-link>
                      {tournament.league.name}
                    </a>
                  </div>
                  <div className="tournament-row__desc">
                    <div className="tournament-row__desc-block">
                      <div className="tournament-row__desc-name">{gettext('Формат игры:')}</div>
                      <div className="tournament-row__desc-value">{tournament.type_game_display}</div>
                    </div>
                    {tournament.completed && tournament.winner ? (
                      <div className="tournament-row__desc-block">
                        <div className="tournament-row__desc-name">{gettext('Победитель:')}</div>
                        <div className="tournament-row__desc-value">
                          <a href={URLS.player_view.replace('0', tournament.winner.id)} data-inside-link>
                            {tournament.winner.short_name}
                          </a>
                        </div>
                      </div>
                    ) : (
                      <div className="tournament-row__desc-block">
                        <div className="tournament-row__name-value">{tournament.title}</div>
                      </div>
                    )}
                  </div>
                </div>
                <div className="tournament-row__extra">
                  <div className='tournament-row__info'>
                    <div className={cn('tournament-row__info-status', `-${Tournaments.getStatus(tournament)}`)}>
                      {Tournaments.getStatusText(tournament)}
                    </div>
                    <div className="tournament-row__info-date">
                      {formattedDate.format(new Date(tournament.date))}
                    </div>
                  </div>
                  <div className={cn("tournament-row__collapse", {
                    '-hide': !tournament.games.length,
                    '-open': opened[tournament.id]
                  })}>
                    <div className="svg-icon">
                      <svg>
                        <use href={`${window.static_urls.svg_sprites_common}#box_arrow_left`}></use>
                      </svg>
                    </div>
                  </div>
                </div>
              </a>
              <Collapse isOpen={opened[tournament.id]}>
                <div className="tournament-games">
                  {tournament.games.map(game => (
                    <a href={URLS.game_view.replace('0', game.id)} key={game.id} className='tournament-games-row'>
                      <GameRowPlayer game={game}/>
                      <div className={cn('tournament-games-row__info', {
                        'hide-m': game.live
                      })}>
                        {game.stage_display}
                      </div>
                      <div className={cn('tournament-games-row__score', {
                        'hide-m': !game.started
                      })}>
                        {game.score_1} : {game.score_2}
                      </div>
                      {/*<div>*/}
                      {/*  <div className={cn('tournament-games-row__live', {*/}
                      {/*    '-hide': !game.live*/}
                      {/*  })}>*/}
                      {/*    Live*/}
                      {/*  </div>*/}
                      {/*</div>*/}
                    </a>
                  ))}
                  <a href={tournament.absolute_url}
                     className='tournament-games__link'>{gettext('Смотреть турнир')}</a>
                </div>
              </Collapse>
            </React.Fragment>))}
        </div>

      </div>
    )
  }
}

const TableTournamentsWithStore = createStore(withStore(TableTournaments), {
  Tournaments
}, {
  tournaments: []
})

const root = ReactDOM.createRoot(document.getElementById('table-tournaments'));
root.render(
  <TableTournamentsWithStore/>
);